export default __webpack_public_path__ + "static/media/btc1.541f30ac.svg";